export default function useListActions() {
  const { createEvent } = useAnalytics()
  const { createToast } = useToasts()
  const guards = useGuards()
  const listsStore = useListsStore()
  const teamsStore = useTeamsStore()

  const togglingFromList = ref(false)

  const toggleCompaniesFromList = async (params: {
    action: 'attach' | 'detach'
    companies?: CompanyV2[]
    list: List
    onToggleCompanies?: (params: {
      action: 'attach' | 'detach'
      companies: CompanyV2[]
    }) => void
    toastDisabled?: boolean
  }) => {
    if (guards.userOnly()) {
      try {
        if (teamsStore.currentTeam?.credits) {
          togglingFromList.value = true

          await listsStore.toggleCompaniesFromList({
            action: params.action,
            companies: params.companies,
            listId: params.list.id,
            onToggleCompanies: params.onToggleCompanies,
          })

          if (params.action === 'detach' && !params.toastDisabled) {
            createToast({
              i18nParams: { name: params.list.name },
              message: 'listRemovedWithName',
            })

            createEvent({ name: '[Lists] Remove Companies From List' })
          }
          else if (params.action === 'attach' && !params.toastDisabled) {
            createToast({
              i18nParams: { name: params.list.name },
              message: 'listAddedWithName',
            })

            createEvent({ name: '[Lists] Add Companies To List' })
          }

          await teamsStore.fetchTeam({ teamId: teamsStore.currentTeam.id })
        }
      }
      catch (error) {
        console.error(error)
      }

      togglingFromList.value = false
    }
  }

  return {
    toggleCompaniesFromList,
    togglingFromList,
  }
}
